import React from 'react';
import { FaTimesCircle, FaCheckCircle } from 'react-icons/fa';


const traditional = [
  {
    title: 'Manual Document Collection',
    desc: 'Collecting documents & data manually through emails is time-consuming and prone to errors.'
  },
  {
    title: 'Paper-Based Workflows',
    desc: 'Traditional methods involve a lot of paperwork, leading to clutter and inefficiency.'
  },
  {
    title: 'Chasing Clients for Documents',
    desc: 'Manually following up for document submissions wastes valuable time.'
  },
  {
    title: 'No Centralized System',
    desc: 'Traditional methods scatter documents across emails and folders.'
  },
  {
    title: 'Risk of Human Error',
    desc: 'Human error in manual data entry and document management can cause costly mistakes.'
  },
  {
    title: 'Limited Transparency',
    desc: `It's hard to track the status of documents in traditional processes.`
  },
  {
    title: 'Slow Turnaround Times',
    desc: 'Manual methods slow down the workflow, affecting project timelines.'
  },
  {
    title: 'No Automated Reminders',
    desc: 'Traditional methods rely on manual follow-ups for deadlines.'
  },
  {
    title: 'Lack of Secure Client Access',
    desc: 'Providing secure access to clients for document exchange can be difficult.'
  },
  {
    title: 'No Cloud Storage Integration',
    desc: 'Documents stored in different locations can lead to inefficiencies.'
  },
  {
    title: 'No Standardized Processes',
    desc: 'Creating new document requests from scratch for every task is time-consuming.'
  },
  {
    title: 'Scattered Communication',
    desc: 'Email-based communications can become disorganized, making it hard to track conversations.'
  },
];

const modern = [
  {
    title: 'Automated Document Collection',
    desc: 'With DocuSafe, document and data collection is automated, allowing you to send customized requests and track submissions in real-time.'
  },
  {
    title: 'Paperless and Digital Workflows',
    desc: 'DocuSafe promotes a fully digital, paperless environment that streamlines workflows and reduces clutter.'
  },
  {
    title: 'Automated Reminders',
    desc: 'DocuSafe sends automated reminders to clients, ensuring timely document submissions without manual effort.'
  },
  {
    title: 'Centralized and Organized',
    desc: 'DocuSafe centralizes all documents and data in one secure platform, making them easily accessible and organized.'
  },
  {
    title: 'Minimized Errors',
    desc: 'DocuSafe reduces errors with automated workflows, ensuring that data is accurate and reliable.'
  },
  {
    title: 'Real-Time Tracking',
    desc: 'DocuSafe offers real-time tracking, giving full visibility into document submissions and approvals.'
  },
  {
    title: 'Faster Turnaround',
    desc: 'DocuSafe accelerates document collection and approvals, enabling faster project completion.'
  },
  {
    title: 'Automated Alerts and Notifications',
    desc: 'DocuSafe automatically sends alerts and notifications, helping ensure that deadlines are met.'
  },
  {
    title: 'Secured Client Portal',
    desc: 'DocuSafe offers a secure, password-protected client portal for seamless and safe document sharing.'
  },
  {
    title: 'Cloud Storage Integration',
    desc: 'DocuSafe integrates with cloud storage platforms like Google Drive, Dropbox, and Box, centralizing all files.'
  },
  {
    title: 'Reusable Templates',
    desc: 'DocuSafe allows you to create reusable templates for common tasks, ensuring consistency and efficiency across all projects.'
  },
  {
    title: 'Messaging System',
    desc: 'DocuSafe\'s built-in messaging system keeps all client interactions organized and within the platform for easy reference.'
  },
];

const Comparison = () => {
  return (
    <section className="comparison-section">
      <div className="comparison-container">
        <div className="comparison-col comparison-left">
          <h2 className="comparison-title traditional">Traditional Way</h2>
          {traditional.map((item, idx) => (
            <div className="comparison-item" key={idx}>
              <span className="comparison-icon fail"><FaTimesCircle /></span>
              <div>
                <div className="comparison-item-title">{item.title}</div>
                <div className="comparison-item-desc">{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
       
        <div className="comparison-col comparison-right">
          <h2 className="comparison-title modern">Docusafe Way</h2>
          {modern.map((item, idx) => (
            <div className="comparison-item" key={idx}>
              <span className="comparison-icon success"><FaCheckCircle /></span>
              <div>
                <div className="comparison-item-title">{item.title}</div>
                <div className="comparison-item-desc">{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Comparison; 